import { render, staticRenderFns } from "./createSubstancia.vue?vue&type=template&id=2e656f23&scoped=true"
import script from "./createSubstancia.vue?vue&type=script&lang=js"
export * from "./createSubstancia.vue?vue&type=script&lang=js"
import style0 from "./createSubstancia.vue?vue&type=style&index=0&id=2e656f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e656f23",
  null
  
)

export default component.exports